import { IBaseDto, BaseDto } from "@/Models/IBaseDto";
import { DateHelper } from '@/Services/Helper/date-helper';

export interface IMedication extends IBaseDto {
	medicationId: number;
	caseId: number;
	medication: string;
	provider: string;
	dosage: string;
	refills: number | null;
	startDate: Date;
	endDate: Date | null;
	isDeleted: boolean;
}

export class MedicationForEdit extends BaseDto implements IMedication {
	medicationId: number;
	caseId: number;
	medication: string;
	provider: string;
	dosage: string;
	refills: number | null;
	startDate: Date;
	endDate: Date | null;
	isDeleted: boolean;

	startDateForEdit: string;
	endDateForEdit: string;

	constructor(src: IMedication) {
		super(src);
		this.medicationId = src.medicationId;
		this.caseId = src.caseId;
		this.medication = src.medication;
		this.provider = src.provider;
		this.dosage = src.dosage;
		this.refills = src.refills;
		this.startDate = src.startDate;
		this.endDate = src.endDate;
		this.isDeleted = src.isDeleted;

		this.startDateForEdit = DateHelper.formatDateUtc(src.startDate, "yyyy-MM-dd");
		this.endDateForEdit = DateHelper.formatDateUtc(src.endDate, "yyyy-MM-dd");
	}
}
